import mixpanel from 'mixpanel-browser';
import { isNativeApp } from 'webtonative';
import { wtnGetOS } from '@/utils';
import { IS_PROD } from '@/constants';

const isRunningInNativeApp = () =>
	typeof window !== 'undefined' && (isNativeApp || Boolean(window.WTN));

const detectOS = () => {
	if (typeof navigator === 'undefined') return 'unknown';
	const ua = navigator.userAgent;
	if (/iphone|ipad|ipod/i.test(ua)) return 'iOS';
	if (/android/i.test(ua)) return 'Android';
	if (/windows/i.test(ua)) return 'Windows';
	if (/mac os|macintosh/i.test(ua)) return 'macOS';
	if (/linux/i.test(ua)) return 'Linux';
	return 'unknown';
};

const detectBrowser = () => {
	if (typeof navigator === 'undefined') return 'unknown';
	const ua = navigator.userAgent;
	if (/edg\//i.test(ua)) return 'Edge';
	if (/opr\/|opera/i.test(ua)) return 'Opera';
	if (/chrome|crios/i.test(ua) && !/edg\//i.test(ua)) return 'Chrome';
	if (/firefox|fxios/i.test(ua)) return 'Firefox';
	if (/safari/i.test(ua) && !/chrome|crios/i.test(ua)) return 'Safari';
	return 'unknown';
};

let analytics: any = {
	init: (_token: any, _config: any) => {
		/* do nothing */
	},
	track: (_eventName: any, _properties = {}) => {
		/* do nothing */
	},
	identify: (_userId: any) => {
		/* do nothing */
	},
	people: {
		set: (_properties: any) => {
			/* do nothing */
		},
	},
};

const lastCalled: Record<string, number> = {};
const DEFAULT_THROTTLE_MS = 2000;

function trackThrottled(eventName: any, properties = {}, wait = DEFAULT_THROTTLE_MS) {
	const now = Date.now();
	if (!lastCalled[eventName] || now - lastCalled[eventName] >= wait) {
		lastCalled[eventName] = now;
		analytics.track(eventName, properties);
	}
}

if (IS_PROD && import.meta.env.VITE_APP_MIXPANEL_KEY) {
	mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_KEY, {
		debug: false,
		track_pageview: true,
		persistence: 'localStorage',
	});

	analytics = mixpanel;

	analytics.register({
		is_native_app: isRunningInNativeApp(),
		os: detectOS(),
		browser: detectBrowser(),
	});

	wtnGetOS().then((nativeOS: any) => {
		if (nativeOS) analytics.register({ os: nativeOS });
	});

	const originalTrack = analytics.track.bind(analytics);
	analytics.track = (eventName: any, properties = {}) => {
		const now = Date.now();
		if (!lastCalled[eventName] || now - lastCalled[eventName] >= DEFAULT_THROTTLE_MS) {
			lastCalled[eventName] = now;
			originalTrack(eventName, properties);
		}
	};

	analytics.trackThrottled = trackThrottled;
}

export default analytics;
